import { RHFInput } from '@talentmesh/ui/components/rhf-input';
import { TypographyMuted } from '@talentmesh/ui/components/typography';
import ProfileGroupForm from './ProfileGroupForm';
import { jobsBaseUrl } from '@/AppSettings';
import UIStrings from '@/Utils/UIStrings';

const domainUrl = URL.canParse(jobsBaseUrl) ? new URL(jobsBaseUrl).hostname : jobsBaseUrl;

function SubdomainSection() {
    return (
        <ProfileGroupForm
            dataCy="SubdomainSection"
            title={UIStrings.SubdomainAsterisk}
            description={UIStrings.YouCanUseLettersNumberAndDashes}
        >
            <div className="flex h-auto w-full max-w-md flex-row items-start">
                <TypographyMuted className="mt-2.75 mr-2 flex-shrink-0 whitespace-nowrap">
                    {`${domainUrl}/`}
                </TypographyMuted>
                <RHFInput className="min-w-0 flex-1" id="companySlug" name="companySlug" type="text" />
            </div>
        </ProfileGroupForm>
    );
}

export default SubdomainSection;
